const BASE_URL = "https://zonemedia.co/"
const Contact_Us_API = BASE_URL + "api/contact.php"
export {Contact_Us_API}